
import {
    Component,
    Input,
    OnInit,
    ViewChild,
    OnDestroy,
    ElementRef,
} from "@angular/core";

import { Table } from "primeng/table";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { FilterdataService } from "src/app/argic/services/filterdata.service";
import { ChangeRequestChatService } from "src/app/argic/services/change-request-chat.service";
import {
    Bodytype,
    Characteristic,
    EurocodeRecord,
    Glassposition,
    Glasstint,
    Glasstype,
    Model,
} from "../domain/eurocode";
import { Searchquery } from "src/app/argic/models/searchquery";
import { MessageService, SelectItem } from "primeng/api";
import { AcType } from "src/app/models/ac-type";
import { Manufacturer } from "src/app/models/manufacturer";
import { LoginService } from "src/app/login/login.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ExportExcelService } from "src/app/argic/services/export-excel.service";
import jsPDF from "jspdf";
import { HttpClient } from "@angular/common/http";
import { HttpErrorResponse } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { EurocodeHistoric } from "../domain/eurocodehistoric";
import { EurocodeChangeRequest } from "../domain/eurocodechangerequest";
import { debounceTime, take } from "rxjs/operators";

@Component({
    selector: "app-table",
    templateUrl: "./matrixsearch.component.html",
    styleUrls: ["./matrixsearch.scss"],
    providers: [MessageService],
    styles: [
        `
            @media screen and (max-width: 960px) {
                :host
                    ::ng-deep
                    .p-datatable.p-datatable-customers.rowexpand-table
                    .p-datatable-tbody
                    > tr
                    > td:nth-child(6) {
                    display: flex;
                }
            }
        `,
    ],
})
export class MatrixSearchComponent implements OnInit, OnDestroy {
    @Input() isReady: BehaviorSubject<boolean>;

    searchdata$ = new BehaviorSubject<Searchquery | null>(null);

    selectedItem: EurocodeRecord;
    historySelectedItem: EurocodeChangeRequest;
    statuses: any[];
    detailDialogVisible = false;
    requestDialogVisible = false;
    historyDialogVisible = false;
    adminUploadDialogVisible = false;

    hosturl: string = environment.apiWizardUrl;

    product = {};
    public EurocodeFiles: any[] = [];

    rowGroupMetadata: any;

    activityValues: number[] = [0, 100];

    private mySubscriptions: Subscription[] = [];

    public historics: EurocodeHistoric[] = [];
    public changeRequests: EurocodeChangeRequest[] = [];

    @ViewChild("dt") table: Table;

    cols: any[];
    items: any[];
    isSelectedTypeAcc: boolean = false;
    isSelectedTypeGlass: boolean = false;

    eurocode: string;
    createdFrom: Date;
    createdTo: Date;
    euroReferenceType: any;
    euroReferenceQuery: string;
    selectedType: string;
    sopMonth: any;
    sopYear: any;
    eopMonth: any;
    eopYear: any;
    countries: any[];

    euroReferences: any[];
    filteredCountries: any[];
    filteredAcTypes: AcType[];
    filteredManufacturers: Manufacturer[];
    filteredModels: Model[];
    filteredCharacteristics: Characteristic[];
    filteredGlasstints: any[];
    filteredGlasspositions: any[];
    filteredGlasstoptints: any[];
    filteredGlasstypes: any[];
    filteredBodytypes: any[];

    selectedCountryAdvanced: any[];
    selectedAcType: any[];
    selectedManufacturer: any[];
    selectedModel: any[];
    selectedCharacteristic: any[];
    selectedBodytype: any[];
    selectedGlassposition: any[];
    selectedGlasstint: any[];
    selectedGlasstoptint: any[];
    selectedGlasstype: any[];

    valSlider = 50;
    valColor = "#424242";
    valRadio: string;
    valCheck: string[] = [];
    valSwitch: boolean;
    cities: SelectItem[];
    selectedList: SelectItem;
    selectedDrop: SelectItem;
    selectedMulti: string[] = [];
    valToggle = false;
    paymentOptions: any[];
    valSelect1: string;
    valSelect2: string;
    valueKnob = 20;

    actypes: AcType[];
    manufacturers: Manufacturer[];
    models: Model[];
    characteristics: Characteristic[];
    bodytypes: Bodytype[];
    glasstypes: Glasstype[];
    glasstints: Glasstint[];
    glasstoptints: Glasstint[];
    glasspositions: Glassposition[];

    sopMonths: any[] = [];
    sopYears: any[] = [];
    eopMonths: any[] = [];
    eopYears: any[] = [];
    advanced: boolean;
    oem: any;
    oes: any;
    detailDialogVisible2: boolean;
    autover: any;
    agc: any;
    description: any;

    loading: boolean;
    multi: string;
    exportColumns: any[];
    colsPdf: any[];

    myFiles: string[] = [];
    myAdminFiles: string[] = [];
    sMsg: string = '';

    pendingUploadGuids: string[] = [];
    pendingUploadFileNames: string[] = [];
    hasActiveUploads: boolean = false;
    private uploadedFileKeys = new Set<string>();

    initialized = false;

    constructor(
        public ete: ExportExcelService,
        private route: ActivatedRoute,
        private router: Router,
        private loginService: LoginService,
        private fdService: FilterdataService,
        private filterdataService: FilterdataService,
        private httpService: HttpClient,
        private messageService: MessageService,
        private changeRequestService: ChangeRequestChatService
    ) { }

    removeFromFiles(filename: string) {
        var index = this.myFiles.indexOf(filename);
        this.myFiles.splice(index, 1);
    }

    removeFromAdminFiles(filename: string) {
        var index = this.myAdminFiles.indexOf(filename);
        this.myAdminFiles.splice(index, 1);
    }

    humanFileSize(bytes: number): string {
        if (Math.abs(bytes) < 1024) {
            return bytes + ' B';
        }
        const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        let u = -1;
        do {
            bytes /= 1024;
            u++;
        } while (Math.abs(bytes) >= 1024 && u < units.length - 1);
        return bytes.toFixed(1) + ' ' + units[u];
    }

    getFileDetails(e) {
        const files = e.currentFiles || e.files || (e.target && e.target.files) || [];
        for (var i = 0; i < files.length; i++) {
            const file = files[i];

            // Skip files that were already uploaded in a previous onSelect event
            const fileKey = `${file.name}_${file.size}`;
            if (this.uploadedFileKeys.has(fileKey)) {
                continue;
            }

            if (file.size > 10 * 1024 * 1024) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'File Too Large',
                    detail: `${file.name} exceeds 10MB limit`
                });
                continue;
            }

            if (this.pendingUploadGuids.length >= 10) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Maximum Files',
                    detail: 'Maximum 10 attachments allowed'
                });
                continue;
            }

            this.uploadedFileKeys.add(fileKey);
            this.myFiles.push(file);
            this.hasActiveUploads = true;

            this.changeRequestService.uploadFileTemporary(file).subscribe({
                next: (response) => {
                    this.pendingUploadGuids.push(response.guid);
                    this.pendingUploadFileNames.push(file.name);
                    this.hasActiveUploads = false;
                },
                error: (err) => {
                    this.uploadedFileKeys.delete(fileKey);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Upload Failed',
                        detail: `Failed to upload ${file.name}`
                    });
                    this.hasActiveUploads = false;
                }
            });
        }
    }

    public uploading = false;
    uploadFiles(comments: any, uploader: any) {

        if (this.uploading) {
            return;
        }

        if (!comments?.value?.trim()) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Comments are required'
            });
            return;
        }

        if (this.hasActiveUploads) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Uploading',
                detail: 'Please wait for files to finish uploading'
            });
            return;
        }

        this.uploading = true;

        const eurocode = this.selectedItem.v1 ? this.selectedItem.eurocodeOLD : this.selectedItem.eurocode;

        const createRequest = {
            Eurocode: eurocode ?? 'NO CODE',
            Description: comments.value,
            AttachmentGuids: this.pendingUploadGuids,
            AttachmentFileNames: this.pendingUploadFileNames
        };

        this.changeRequestService.createChangeRequest(createRequest).subscribe({
            next: (response) => {
                this.messageService.add({
                    key: "Submitted",
                    severity: "info",
                    summary: "Submitted",
                    detail: "Thank you for your enquiry. The Argic Team will inform you as soon as possible.",
                });
                this.hideRequestDialog();
                this.resetUploadState(uploader);
                this.uploading = false;
            },
            error: (err: HttpErrorResponse) => {
                console.log(err.message);
                this.messageService.add({
                    key: "Submitted",
                    severity: "error",
                    summary: "Error",
                    detail: "An error occurred while submitting your request. Please try again.",
                });
                this.uploading = false;
            }
        });
    }

    resetUploadState(uploader: any) {
        this.myFiles = [];
        this.pendingUploadGuids = [];
        this.pendingUploadFileNames = [];
        this.uploadedFileKeys.clear();
        this.hasActiveUploads = false;
        if (uploader) {
            uploader.clear();
        }
    }

    uploadAdminFiles(uploaderAdmin: any) {
        const frmData = new FormData();
        frmData.append("Form", "change_request_form");
        frmData.append("Eurocode", this.selectedItem.eurocode ?? 'NO CODE');
        this.myAdminFiles = uploaderAdmin.files;

        for (var i = 0; i < this.myAdminFiles.length; i++) {
            frmData.append("Files", this.myAdminFiles[i]);
        }

        this.httpService.post(environment.localUrl + 'Upload/UploadAdmin', frmData)
        .pipe(debounceTime(2000)) 
        .subscribe(
            data => {
                this.messageService.add({
                    key: "Submitted",
                    severity: "info",
                    summary: "Submitted",
                    detail: "Upload finished.",
                });
                this.hideAdminUploadDialog();
            },
            (err: HttpErrorResponse) => {
                console.log(err.message);    // Show error, if any.
            }
        );
    }

    exportPdfAutotable() {
        this.colsPdf = [
            { field: "eurocode", header: "Eurocode" },
            { field: "fulldescription", header: "Description" },
            { field: "category", header: "Category" },
            { field: "quantity", header: "Quantity" },
        ];
        this.exportColumns = this.cols.map((col) => ({
            title: col.header,
            dataKey: col.field,
        }));

        let body = [];
        this.items.forEach((e: any) =>
            body.push([
                e.v1?e.eurocodeOLD:e.eurocode,
                e.man_EN,
                e.modelDescription,
                e.fulldescription,
                e.oem,
            ])
        );

        import("jspdf").then((jsPDF) => {
            import("jspdf-autotable").then((x) => {
                const doc = new jsPDF.default("l", "cm");
                (doc as any).autoTable({
                    head: [
                        [
                            "Eurocode",
                            "Manufacturer",
                            "Model",
                            "Description",
                            "OE",
                        ],
                    ],
                    body: body,
                });
                doc.save("export.pdf");
            });
        });
    }

    ngOnInit() {
        this.loading = true;

        const sub1 = this.isReady.pipe(take(2)).subscribe((ready) => {
            if (ready) {

                let sub2 = this.searchdata$.subscribe((d) => {
                    if (d) {
                        this.loading = true;

                        this.fdService.getAll(d).subscribe((d) => {
                            this.items = d;
                            this.loading = false;
                        });
                    }
                });
                this.mySubscriptions.push(sub2);

                this.loading = false;
                this.initialize();
                this.loadHistory();
            }
        });

        this.mySubscriptions.push(sub1);
    }

    private loadHistory() {
        if (history.state && history.state.sitesearch) {
            this.multi = history.state.sitesearch;
            this.doSearch();
        } else {
            let matrixsearch = window.localStorage.getItem('matrixsearch');
            if (matrixsearch != null) {
                window.localStorage.removeItem('matrixsearch');
                this.multi = matrixsearch;
                this.doSearch();
            } else {
                //empty initial search
                const searchQuery = new Searchquery();
                searchQuery.language = this.loginService.userprofile.languageId;
                searchQuery.userid = this.loginService.userprofile.userid;
                searchQuery.login = this.loginService.userprofile.login;
                this.searchdata$.next(searchQuery);
            }
        }
    }


    initialize() {


        this.cols = [
            { field: "manufacturer", header: "Manufacturer" },
            { field: "model", header: "Model" },
            { field: "description", header: "Description" },
            { field: "description", header: "Description" },
            { field: "description", header: "Description" },
        ];

        this.statuses = [
            { label: "Unqualified", value: "unqualified" },
            { label: "Qualified", value: "qualified" },
            { label: "New", value: "new" },
            { label: "Negotiation", value: "negotiation" },
            { label: "Renewal", value: "renewal" },
            { label: "Proposal", value: "proposal" },
        ];

        this.euroReferences = [
            { name: "AGC", value: "AGC" },
            { name: "AUTOVER", value: "AUTOVER" },
            { name: "OEM", value: "OEM" },
            { name: "OES", value: "OES" },
        ];

        for (let i = 1; i <= 12; i++) {
            this.sopMonths.push({ name: i, value: i });
        }

        for (let i = new Date().getFullYear(); i >= 1909; i--) {
            this.sopYears.push({ name: i, value: i });
        }

        for (let i = 1; i <= 12; i++) {
            this.eopMonths.push({ name: i, value: i });
        }

        for (let i = new Date().getFullYear(); i >= 1909; i--) {
            this.eopYears.push({ name: i, value: i });
        }

        this.filterdataService.getAcTypes().subscribe((d) => {
            let langid = this.loginService.userprofile.languageId;

            let langfield;
            switch (langid) {
                case 1:
                    langfield = "acType_En";
                    break;
                case 2:
                    langfield = "acType_De";
                    break;
                case 3:
                    langfield = "acType_Fr";
                    break;
                case 4:
                    langfield = "acType_It";
                    break;
                case 5:
                    langfield = "acType_Es";
                    break;
                case 6:
                    langfield = "acType_Nl";
                    break;
            }
            var d2 = d.map((e) => {
                return { ...e, description: e[langfield] };
            });
            this.actypes = d2;
        });
        this.filterdataService.getGlasstypes().subscribe((d) => {
            let langid = this.loginService.userprofile.languageId;

            let langfield;
            switch (langid) {
                case 1:
                    langfield = "glassType_En";
                    break;
                case 2:
                    langfield = "glassType_De";
                    break;
                case 3:
                    langfield = "glassType_Fr";
                    break;
                case 4:
                    langfield = "glassType_It";
                    break;
                case 5:
                    langfield = "glassType_Es";
                    break;
                case 6:
                    langfield = "glassType_Nl";
                    break;
            }
            var d2 = d.map((e) => {
                return { ...e, description: e[langfield] ?? "" };
            });
            this.glasstypes = d2;
        });
        this.filterdataService.getManufacturers().subscribe((d) => {
            let langid = this.loginService.userprofile.languageId;

            let langfield;
            switch (langid) {
                case 1:
                    langfield = "man_En";
                    break;
                case 2:
                    langfield = "man_De";
                    break;
                case 3:
                    langfield = "man_Fr";
                    break;
                case 4:
                    langfield = "man_It";
                    break;
                case 5:
                    langfield = "man_Es";
                    break;
                case 6:
                    langfield = "man_Nl";
                    break;
            }

            var d2 = d.map((e) => {
                return { ...e, description: e[langfield] };
            });
            this.manufacturers = d2;
        });

        this.models = [];

        this.filterdataService.getCharacteristics().subscribe((d) => {
            this.characteristics = d;
            this.filteredCharacteristics = d;
        });
        this.filterdataService.getGlasstints().subscribe((d) => {
            this.glasstints = d;
        });
        this.filterdataService.getGlasstoptints().subscribe((d) => {
            this.glasstoptints = d;
        });
        this.filterdataService.getGlasspositions().subscribe((d) => {
            let langid = this.loginService.userprofile.languageId;
            let langfield;
            switch (langid) {
                case 1:
                    langfield = "glassposition_En";
                    break;
                case 2:
                    langfield = "glassposition_De";
                    break;
                case 3:
                    langfield = "glassposition_Fr";
                    break;
                case 4:
                    langfield = "glassposition_It";
                    break;
                case 5:
                    langfield = "glassposition_Es";
                    break;
                case 6:
                    langfield = "glassposition_Nl";
                    break;
            }
            var d2 = d.map((e) => {
                return { ...e, description: e[langfield] ?? "" };
            });
            this.glasspositions = d2;
        });
        this.filterdataService.getBodytypes().subscribe((d) => {
            let langid = this.loginService.userprofile.languageId;
            let langfield;
            switch (langid) {
                case 1:
                    langfield = "bodyType_En";
                    break;
                case 2:
                    langfield = "bodyType_De";
                    break;
                case 3:
                    langfield = "bodyType_Fr";
                    break;
                case 4:
                    langfield = "bodyType_It";
                    break;
                case 5:
                    langfield = "bodyType_Es";
                    break;
                case 6:
                    langfield = "bodyType_Nl";
                    break;
            }
            var d2 = d.map((e) => {
                return { ...e, description: e[langfield] ?? "" };
            });
            this.bodytypes = d2;
        });

    }

    ngOnDestroy() {
        this.mySubscriptions.forEach((e) => e.unsubscribe);
    }

    topSearch(value: string, col: string) {
        if (col === "eurocode" && value.length < 3) return;
        this.doSearch();
    }

    onManuChange() {
        this.filterModels({ query: "" });
        this.doSearch();
    }

    onModelChange() {
        this.doSearch();
    }

    onChangeGlasstype() {
        this.filterCharacteristics({ query: "" });
    }

    filterAcTypes(event) {
        const filtered: any[] = [];
        const query = event.query;
        this.actypes.forEach((e) => {
            if (e.acType_En.toLowerCase().indexOf(query.toLowerCase()) == 0)
                filtered.push(e);
            else if (e.acType.toLowerCase().indexOf(query.toLowerCase()) == 0)
                filtered.push(e);
        });
        this.filteredAcTypes = filtered;
    }

    filterGlasstypes(event) {
        const filtered: any[] = [];
        const query = event.query;
        this.glasstypes.forEach((e) => {
            if (e.description.toLowerCase().indexOf(query.toLowerCase()) == 0)
                filtered.push(e);
            else if (
                e.description.toLowerCase().indexOf(query.toLowerCase()) == 0
            )
                filtered.push(e);
        });
        this.filteredGlasstypes = filtered;
    }

    filterManufacturers(event) {
        const filtered: any[] = [];
        const query = event.query;
        if (this.manufacturers)
            this.manufacturers.forEach((e) => {
                if (e.description.toLowerCase().includes(query.toLowerCase()))
                    filtered.push(e);
            });
        this.filteredManufacturers = filtered;
    }

    filterModels(event) {
        const filtered: any[] = [];
        const query = event.query;
        if (this.selectedManufacturer == null) {
            this.filteredModels = [];
            return;
        }
        let searchdata = {
            /*mancodes: this.selectedManufacturer["manCodes"], */
            manids: this.selectedManufacturer["manIds"]
        };
        this.filterdataService.getModelsQuery(searchdata).subscribe((d) => {
            let langid = this.loginService.userprofile.languageId;
            let langfield;
            switch (langid) {
                case 1:
                    langfield = "mod_En";
                    break;
                case 2:
                    langfield = "mod_De";
                    break;
                case 3:
                    langfield = "mod_Fr";
                    break;
                case 4:
                    langfield = "mod_It";
                    break;
                case 5:
                    langfield = "mod_Es";
                    break;
                case 6:
                    langfield = "mod_Nl";
                    break;
            }
            var d2 = d.map((e) => {
                return { ...e, description: e[langfield] };
            });
            this.models = d2;
            this.models.forEach((e) => {
                if (
                    e.description != null &&
                    e.description.toLowerCase().includes(query.toLowerCase())
                )
                    filtered.push(e);
            });
            this.filteredModels = filtered;
        });
    }

    filterTopTints(event) {
        const filtered: any[] = [];
        const query = event.query;
        this.glasstoptints.forEach((e) => {
            if (e.glassTint_En.toLowerCase().indexOf(query.toLowerCase()) == 0)
                filtered.push(e);
            else if (
                e.glassTint_En.toLowerCase().indexOf(query.toLowerCase()) == 0
            )
                filtered.push(e);
        });
        this.filteredGlasstoptints = filtered;
    }

    filterTints(event) {
        const filtered: any[] = [];
        const query = event.query;
        this.glasstints.forEach((e) => {
            if (e.glassTint_En.toLowerCase().indexOf(query.toLowerCase()) == 0)
                filtered.push(e);
            else if (
                e.glassTint_En.toLowerCase().indexOf(query.toLowerCase()) == 0
            )
                filtered.push(e);
        });
        this.filteredGlasstints = filtered;
    }

    filterBodytypes(event) {
        const filtered: any[] = [];
        const query = event.query;
        this.bodytypes.forEach((e) => {
            if (e.bodyType_En.toLowerCase().indexOf(query.toLowerCase()) == 0)
                filtered.push(e);
            else if (
                e.bodyType_En.toLowerCase().indexOf(query.toLowerCase()) == 0
            )
                filtered.push(e);
        });
        this.filteredBodytypes = filtered;
    }

    filterGlasspositions(event) {
        const filtered: any[] = [];
        const query = event.query;
        this.glasspositions.forEach((e) => {
            if (
                e.glassposition_En.toLowerCase().indexOf(query.toLowerCase()) ==
                0
            )
                filtered.push(e);
            else if (
                e.glassposition_En.toLowerCase().indexOf(query.toLowerCase()) ==
                0
            )
                filtered.push(e);
        });
        this.filteredGlasspositions = filtered;
    }

    filterCharacteristics(event) {
        const filtered: any[] = [];
        const query = event.query;

        if (this.selectedGlasstype == null) {
            this.characteristics.forEach((e) => {
                if (e.en.toLowerCase().indexOf(query.toLowerCase()) == 0)
                    filtered.push(e);
                else if (e.en.toLowerCase().indexOf(query.toLowerCase()) == 0)
                    filtered.push(e);
            });
        } else {
            let gt = this.selectedGlasstype["glassTypeId"];
            this.characteristics.forEach((e) => {
                if (e.glassTypeID !== gt) return;
                if (e.en.toLowerCase().indexOf(query.toLowerCase()) == 0)
                    filtered.push(e);
                else if (e.en.toLowerCase().indexOf(query.toLowerCase()) == 0)
                    filtered.push(e);
            });
        }
        this.filteredCharacteristics = filtered;
    }

    doSearch() {
        let searchQuery = new Searchquery();

        searchQuery.language = this.loginService.userprofile.languageId;
        searchQuery.userid = this.loginService.userprofile.userid;
        searchQuery.login = this.loginService.userprofile.login;

        if (this.eurocode && this.eurocode.length > 0) {
            searchQuery.textquery = this.eurocode.replace("%", "*");
        }

        if (this.description && this.description.length > 0) {
            searchQuery.descriptionquery = this.description.replace("%", "*");
        }
        if (this.multi && this.multi.length > 0) {
            searchQuery.multiquery = this.multi.replace("%", "*");
            this.multi = null;
        }

        if (this.createdFrom) searchQuery.createdfrom = this.createdFrom;
        if (this.createdTo) searchQuery.createdto = this.createdTo;
        if (this.selectedType) searchQuery.selectedtype = this.selectedType;

        if (this.oem && this.oem.length) {
            this.euroReferenceType = { value: "OEM" };
            this.euroReferenceQuery = this.oem;
        }

        if (this.oes && this.oes.length) {
            this.euroReferenceType = { value: "OES" };
            this.euroReferenceQuery = this.oes;
        }

        if (this.autover && this.autover.length) {
            this.euroReferenceType = { value: "AUTOVER" };
            this.euroReferenceQuery = this.autover;
        }

        if (this.agc && this.agc.length) {
            this.euroReferenceType = { value: "AGC" };
            this.euroReferenceQuery = this.agc;
        }

        if (this.euroReferenceType)
            searchQuery.euroreferencetype = this.euroReferenceType.value;
        if (this.euroReferenceQuery)
            searchQuery.euroreferencequery = this.euroReferenceQuery.replace("%", "*");

        if (this.sopYear) searchQuery.sopyear = this.sopYear.value;
        if (this.sopMonth) searchQuery.sopmonth = this.sopMonth.value;
        if (this.eopYear) searchQuery.eopyear = this.eopYear.value;
        if (this.eopMonth) searchQuery.eopmonth = this.eopMonth.value;

        if (this.selectedManufacturer)
            searchQuery.manids = this.selectedManufacturer["manIds"];

        searchQuery.mancodes = null;
        if (this.selectedGlasstype)
            searchQuery.matrixtypeid = this.selectedGlasstype["matrixTypeId"];
        if (this.selectedGlasstype)
            searchQuery.glasstypeid = this.selectedGlasstype["glassTypeId"];
        if (this.selectedModel) searchQuery.modid = this.selectedModel["modId"];
        if (this.selectedCharacteristic) {
            var chars = "";
            this.selectedCharacteristic.forEach((element) => {
                chars += element["charID"];
            });
            searchQuery.charid = chars;
        }

        if (this.selectedGlasstint)
            searchQuery.glasstintid = this.selectedGlasstint["glassTint"];
        if (this.selectedGlasstoptint)
            searchQuery.glasstoptintid = this.selectedGlasstoptint["glassTint"];
        if (this.selectedBodytype)
            searchQuery.bodytypeid = this.selectedBodytype["bodyType"];
        if (this.selectedGlassposition)
            searchQuery.glasspositionid =
                this.selectedGlassposition["glassposition"];
        if (this.selectedAcType)
            searchQuery.actypeid = this.selectedAcType["acType"];

        this.searchdata$.next(searchQuery);
    }

    flatten(arr: string[]) {
        return arr.join(",");
    }

    doReset() {
        this.eurocode = null;
        this.createdFrom = null;
        this.createdTo = null;
        this.selectedType = null;
        this.selectedManufacturer = null;
        this.selectedGlasstoptint = null;
        this.selectedGlasstype = null;
        this.selectedModel = null;
        this.selectedGlasstint = null;
        this.selectedGlassposition = null;
        this.selectedCharacteristic = null;
        this.selectedBodytype = null;
        this.selectedAcType = null;
        this.euroReferenceType = null;
        this.euroReferenceQuery = null;
        this.sopYear = null;
        this.sopMonth = null;
        this.eopYear = null;
        this.eopMonth = null;
        this.description = null;
        this.multi = null;
        this.oes = null;
        this.oem = null;
        this.autover = null;
        this.agc = null;
        let sq = new Searchquery();
        sq.language = this.loginService.userprofile.languageId;
        sq.userid = this.loginService.userprofile.userid;
        sq.login = this.loginService.userprofile.login;
        this.searchdata$.next(sq);
    }

    onSelectedTypeClick() {
        this.isSelectedTypeAcc = false;
        this.isSelectedTypeGlass = false;
        if (this.selectedType == "glass") {
            this.isSelectedTypeGlass = true;
        } else if (this.selectedType == "acc") {
            this.isSelectedTypeAcc = true;
        }
    }
    setAdvanced() {
        this.advanced = !this.advanced;
    }

    onSort() {
        this.updateRowGroupMetaData();
    }

    updateRowGroupMetaData() {
        this.rowGroupMetadata = {};
    }

    openDetail(eurocode: string, row: any) {
        this.fdService.getOne(eurocode, this.searchdata$.getValue()).subscribe((d) => {
            this.fdService.getManufacturer(d.model.manId).subscribe((m) => {
                this.selectedItem = d;
                this.selectedItem.model.manufacturer = m;
                this.selectedItem.row = row;
            });

            //get the history records
            // this.fdService.getHistorics(d.eurocode).subscribe(data => {
            //     this.historics = data;
            // });

            //get the history records
            this.fdService.getEurocodeHis(d.eurocode).subscribe(data => {
                this.changeRequests = data;
            });

            this.fdService.getFiles(d.eurocode).subscribe(data => {
                this.EurocodeFiles = data;
            });

        });
        this.detailDialogVisible = true;
    }

    openDetail2(eurocode: string, row: any) {
        this.fdService.getOne(eurocode, this.searchdata$.getValue()).subscribe((d) => {
            this.fdService.getManufacturer(d.model.manId).subscribe((m) => {
                this.selectedItem = d;
                this.selectedItem.model.manufacturer = m;
                this.selectedItem.row = row;
            });

            // get the history records
            this.fdService.getHistorics(d.eurocode).subscribe(data => {
                this.historics = data;
            });

            //get the history records
            this.fdService.getEurocodeHis(d.eurocode).subscribe(data => {
                this.changeRequests = data;
            });



        });
        this.detailDialogVisible2 = true;
    }


    openRequestDialog(eurocode: string, row: any) {
        //refresh the data for the row
        this.fdService.getOne(eurocode, this.searchdata$.getValue()).subscribe((d) => {
            this.fdService.getManufacturer(d.model.manId).subscribe((m) => {
                this.selectedItem = d;
                this.selectedItem.model.manufacturer = m;
                this.selectedItem.row = row;
            });
        });
        this.requestDialogVisible = true;
    }


    openAdminUploadDialog(eurocode: string, row: any) {
        //refresh the data for the row
        this.fdService.getOne(eurocode, this.searchdata$.getValue()).subscribe((d) => {
            this.fdService.getManufacturer(d.model.manId).subscribe((m) => {
                this.selectedItem = d;
                this.selectedItem.model.manufacturer = m;
                this.selectedItem.row = row;
            });
        });
        this.adminUploadDialogVisible = true;
    }


    hideDialog() {
        this.detailDialogVisible = false;
    }
    hideDialog2() {
        this.detailDialogVisible2 = false;
    }
    hideRequestDialog() {
        this.requestDialogVisible = false;
    }
    hideAdminUploadDialog() {
        this.adminUploadDialogVisible = false;
    }

    title = "argic-export-to-excel";

    dataForExcel = [];

    exportExcel() {
        let items2 = this.items as any[];
        let exportitems: any[] = items2.map((x) => {
            return {
                eurocode: x.v1?x.eurocodeOLD:x.eurocode,
                description: x.fulldescription,
                manufacturer: x.man_EN,
                model: x.modelDescription,
                oem: x.oem,
                autover: x.autover,
                agc: x.agc,
            };
        });

        exportitems.forEach((row: any) => {
            this.dataForExcel.push(Object.values(row));
        });

        let reportData = {
            title: "Export",
            data: this.dataForExcel,
            headers: Object.keys(exportitems[0]),
        };

        this.ete.exportExcel(reportData);
    }

    @ViewChild("pdfcontent", { static: true }) pdfcontent: ElementRef;

    public exportPdf(): void {
        let pdfcontent = this.pdfcontent.nativeElement;
        let doc = new jsPDF();
        let _elementHandlers = {
            "#editor": function (element, renderer) {
                return true;
            },
        };
        //console.log(pdfcontent.innerHTML);
        doc.text("Export data and lay-out to be determined", 20, 20);

        doc.save("export.pdf");
    }

    public openHistoryDetail(eventData) {
        this.fdService.getManufacturer(eventData.model.ManId).subscribe((m) => {
            this.historySelectedItem = eventData;
            this.historySelectedItem.model.manufacturer = m;
        });
        this.historyDialogVisible = true;
    }

    getSplittedItems(oem: string): string[] {

        return oem ? oem.split(';').map(item => item.trim()) : [];

    }
}
